<template>
  <div id="q-app">
    <!-- style="background-color:#edffea"-->
    <transition-group
      appear
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div key="div2" v-if="fullLoading" class="loaderOverlay">
        <div key="div2" class="lds-ripple">
          <div key="div3"></div>
          <div key="div4"></div>
        </div>
      </div>
    </transition-group>
    <div
      v-if="!$route.meta.fullscreen && !$route.path.includes('/waves')"
      :style="
        `width: 100vw; height: 100px; background: ${
          training ? '#e91e63' : 'white'
        }`
      "
    >
      <q-img
        src="/statics/wavesBlueTextLogoTransparent.png"
        style="height: 100%; width: 200px; left: 15px"
        class="q-pl-sm"
        contain
      >
      </q-img>
      <association-selector />

      <q-img
        v-if="$q.screen.gt.sm && false"
        src="/statics/swimming.png"
        style="height: 100px; width: 700px"
        contain
        class="float-right"
      >
      </q-img>
    </div>

    <q-layout
      view="lHh lpR fFf"
      :style="
        `max-height: calc(100vh - ${
          !$route.path.includes('/waves') ? '100' : '0'
        }px);
        min-height: calc(100vh - ${
          !$route.path.includes('/waves') ? '100' : '0'
        }px) !important;`
      "
    >
      <app-bar v-if="!$route.meta.fullscreen && !disableVirtualScrolling" />
      <q-btn
        v-if="disableVirtualScrolling"
        class="q-ml-md q-px-xs"
        color="secondaryButton"
        text-color="accent"
        no-caps
        unelevated
        @click="$store.dispatch('settings/toggleVirtualScrolling')"
        dense
      >
        <q-icon size="xs" name="mdi-close" class="q-mr-sm"></q-icon>
        Disable Print View
      </q-btn>
      <q-page-container
        v-if="!fullLoading"
        class="bg-secondary"
        :style="
          `height: calc(100vh - ${
            !$route.meta.fullscreen
              ? !$route.path.includes('/waves')
              : '100'
              ? '0'
              : '0'
          }px)`
        "
      >
        <q-scroll-area
          v-if="!disableVirtualScrolling"
          :style="
            `height: calc(100vh - ${
              $route.meta.fullscreen
                ? '0'
                : !$route.path.includes('/waves')
                ? '150'
                : '50'
            }px) !important;`
          "
        >
          <router-view
            :class="{
              'q-pa-sm':
                !$route.meta.fullscreen &&
                !$route.path.includes('/waves') &&
                this.$q.screen.lt.sm,
              'q-pa-md':
                !$route.meta.fullscreen &&
                !$route.path.includes('/waves') &&
                this.$q.screen.gt.sm
            }"
          />
        </q-scroll-area>
        <router-view
          v-else
          :class="{
            'q-pa-sm':
              !$route.meta.fullscreen &&
              !$route.path.includes('/waves') &&
              this.$q.screen.lt.sm,
            'q-pa-md':
              !$route.meta.fullscreen &&
              !$route.path.includes('/waves') &&
              this.$q.screen.gt.sm
          }"
        />
      </q-page-container>
    </q-layout>
    <q-dialog v-model="globalMessage" persistent max-width="800px">
      <q-card style="width: 800px; max-width: 90vw">
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              Message from Waves
            </div>
            <q-space />
            <q-btn round flat icon="mdi-close" @click="globalMessage = false">
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="q-pa-sm q-pl-md">
          Hi Team, <br />
          <br />
          We have made some updates to data in our system so just a reminder
          that only members that are current 2023-24 season will be in your
          association member lists and be able to be entered into our amazing
          competitions over summer. <br />
          <br />
          Cheers SLSNZ Sport.
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { auth } from "@/firebase.js";
import { mapGetters } from "vuex";
import AppBar from "@/components/AppBar";
import { colors } from "quasar";
import api from "./api";
import AssociationSelector from "@/components/associations/associationSelector.vue";

export default {
  components: {
    AppBar,
    AssociationSelector
  },
  computed: {
    ...mapGetters({
      fullLoading: "settings/fullLoading",
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      offlineMode: "offlineMode",
      darkMode: "settings/darkMode",
      disableVirtualScrolling: "settings/disableVirtualScrolling"
    })
  },
  data: () => ({
    training: false,
    globalMessage: false
  }),
  watch: {
    currentUser: function(oldData, newData) {
      this.checkLoggedIn();
    },
    $route: function(newRoute, oldRoute) {
      this.checkLoggedIn();
    },
    currentUserData: function() {
      this.displayGlobalMessage();
    },
    darkMode: function() {
      this.themeInit();
    }
  },
  mounted() {
    this.checkLoggedIn();
    this.themeInit();
    this.training = api.defaults.baseURL.includes("_training");
    if (this.currentUserData) {
      this.displayGlobalMessage();
    }
  },
  methods: {
    displayGlobalMessage() {
      if (
        [
          "Club Admin",
          "Team Manager",
          "Coach",
          "Sports Coordinator",
          "Junior Coordinator"
        ].includes(this.currentUserData.role) &&
        this.currentUserData.currentGlobalMessageRead == 0
      ) {
        this.globalMessage = true;
      }
    },
    themeInit() {
      this.$q.dark.set(this.darkMode);
      if (this.$q.dark.isActive) {
        colors.setBrand("secondary", "#252525");
        colors.setBrand("headerColor", "#222222");
        colors.setBrand("headerButton", "#ffffff");
      } else {
        colors.setBrand("secondary", "#edf5f8");
        colors.setBrand("headerColor", "#ffffff");
        colors.setBrand("headerButton", "#222222");
      }
    },
    checkLoggedIn() {
      // var ts = Math.round(new Date().getTime() / 1000);
      if (this.currentUser != null && this.currentUser != "loading") {
        if (this.$route.path === "/login") {
          this.$router.push("/");
        }
      } else if (this.currentUser != "loading") {
        if (this.$route.path != "/login") {
          this.$router.push("/login");
        }
      }
    }
  }
};
</script>

<style lang="scss">
::-webkit-scrollbar {
  width: 5px;
  height: 10px;
}
::-webkit-scrollbar-track {
  background: $scrollbarTrack;
}
::-webkit-scrollbar-thumb {
  background: $scrollbarThumb;
}
::-webkit-scrollbar-thumb:hover {
  background: $scrollbarHover;
}
.loaderOverlay {
  z-index: 9999;
  background: $accent;
  width: 100vw;
  height: 100vh;
  position: fixed;
}
.lds-ripple {
  top: calc(50vh - 40px);
  left: calc(50vw - 40px);
  display: inline-block;
  position: fixed;
  width: 80px;
  height: 80px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid $primary;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
.swal2-container {
  z-index: 10060 !important;
}
.q-header {
  position: absolute !important;
}
.q-page {
  min-height: calc(100vh - 150px) !important;
  max-height: calc(100vh - 150px) !important;
}
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}
</style>
